import React, { useEffect, useState } from 'react';

import {
  headersTransferenciasOrgInter,
  valoresExibidosTransferenciasOrgInter,
} from './auxiliarTransferenciasFinanceiras';
import BarraInferiorBotoes from '../../../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomButton from '../../../../../../../components/CustomButton';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Input from '../../../../../../../components/InputNew';
import Select from '../../../../../../../components/InputNew/Select';
import Log from '../../../../../../../components/Log/Log';
import Modal from '../../../../../../../components/Modal';
import Tabela from '../../../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import { useStatusTransfFin } from '../../../../../../../services/enum/useStatusTransFinanceira';
import httpClient, {
  isHttpError,
} from '../../../../../../../services/httpClient';
import { getTransfFinPorOrgInter } from '../../../../../../../services/orgInters/orgInterTransfFinService';
import theme from '../../../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarValorFormatoDinheiro,
  formatDate,
  formatDateSimp,
  formatoMoney,
  formatValorDinheiro,
  parseInputMonetario,
} from '../../../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../../../utils/swal';
import { useOrgInterDadosGerais } from '../../context/dadosGeraisContext';

interface Props {
  orgInter: number;
  userID: number;
}

type TransferenciaFinanceiraType = {
  id: number;
  usuarioId: number;
  orgInterId: number;
  statusTransferencia: number;
  dataContrato: string;
  contratoCambio: string;
  valorTransferido: string;
  valorTotalDolares: string;
  cotacaoDolar: string;
  observacoes: string;
};

export default function TransferenciasFinanceirasOrgInter() {
  const { componente, orgInter, userID } = useOrgInterDadosGerais();
  //////STATES
  const [logData, setLogData] = useState<any>();
  const [showModal, setShowModal] = useState(false);
  const [transferenciaFinanceiraId, setTransferenciaFinanceiraId] =
    useState('');
  const [updatingTransferenciaFinanceira, setUpdatingTransferenciaFinanceira] =
    useState(false);
  const statusTransFin = useStatusTransfFin();

  const [data, setData] = useState<any[]>();
  const [formTransferenciaFinanceira, setFormTransferenciaFinanceira] =
    useState<TransferenciaFinanceiraType>({
      id: 0,
      usuarioId: userID,
      orgInterId: orgInter,
      statusTransferencia: 0,
      dataContrato: '',
      contratoCambio: '',
      valorTransferido: '',
      valorTotalDolares: '',
      cotacaoDolar: '',
      observacoes: '',
    });

  //////FETCH DATA
  const fetchTransferenciaFinanceira = async () => {
    try {
      const transferencias = await getTransfFinPorOrgInter(String(orgInter));
      setData(transferencias);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };
  useEffect(() => {
    fetchTransferenciaFinanceira();
  }, []);

  //////TABLE E OFFCANVAS
  const tableData =
    data
      ?.slice() // faz uma cópia para não mutar o array original
      .sort(
        (a, b) =>
          new Date(a.dataContrato).getTime() -
          new Date(b.dataContrato).getTime(),
      )
      .map((item) => {
        // Definindo cores de fundo com base no status do documento
        let statusBackgroundColor = '';
        let colorText = 'black';

        const statusLabel = statusTransFin[item.statusTransferencia]?.label;

        if (statusLabel === 'Aguardando Liberação do Recurso') {
          statusBackgroundColor = theme.colors.amarelogov;
          colorText = 'white';
        } else if (statusLabel === 'Transferido') {
          statusBackgroundColor = theme.colors.verdegov;
          colorText = 'white';
        } else if (statusLabel === 'Suspenso') {
          statusBackgroundColor = theme.colors.laranja;
          colorText = 'white';
        } else if (statusLabel === 'Cancelado') {
          statusBackgroundColor = theme.colors.vermelho;
          colorText = 'white';
        }
        return {
          id: item.id,
          statusTransferencia: (
            <span
              style={{
                backgroundColor: statusBackgroundColor,
                color: colorText,
                borderRadius: '10px',
                padding: '12px',
                display: 'inline-block',
                minWidth: '100px',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {statusLabel}
            </span>
          ),
          contratoCambio: item.contratoCambio || 'Não informado',
          dataContrato: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatDateSimp(item.dataContrato)}
            </span>
          ),
          valorTransferido: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorTransferido)}
            </span>
          ),
          cotacaoDolar: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.cotacaoDolar)}
            </span>
          ),
          valorTotalDolares: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorTotalDolar)}
            </span>
          ),
        };
      }) || [];

  const offCanvasData =
    data?.map((item) => {
      let statusBackgroundColor = '';
      let colorText = 'black';

      const statusLabel = statusTransFin[item.statusTransferencia]?.label;

      if (statusLabel === 'Em Elaboração') {
        statusBackgroundColor = theme.colors.amarelogov;
        colorText = 'white';
      } else if (statusLabel === 'Finalizado') {
        statusBackgroundColor = theme.colors.verdegov;
        colorText = 'white';
      } else if (statusLabel === 'Suspenso') {
        statusBackgroundColor = theme.colors.laranja;
        colorText = 'white';
      } else if (statusLabel === 'Cancelado') {
        statusBackgroundColor = theme.colors.vermelho;
        colorText = 'white';
      }

      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        statusTransferencia: (
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              color: colorText,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              minWidth: '100px',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {statusLabel}
          </span>
        ),
        contratoCambio: item.contratoCambio,
        dataContrato: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatDateSimp(item.dataContrato)}
          </span>
        ),
        valorTransferido: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorTransferido)}
          </span>
        ),
        cotacaoDolar: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.cotacaoDolar)}
          </span>
        ),
        valorTotalDolares: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorTotalDolar)}
          </span>
        ),
        separadorValores: '',
        observacoes: item.observacoes,
      };
    }) || [];

  //////FUNÇÕES HANDLE
  const handleClearForm = () => {
    setFormTransferenciaFinanceira({
      id: 0,
      usuarioId: userID,
      orgInterId: orgInter,
      statusTransferencia: 0,
      dataContrato: '',
      contratoCambio: '',
      valorTransferido: '',
      valorTotalDolares: '',
      cotacaoDolar: '',
      observacoes: '',
    });
    setLogData({
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleShowModal = () => setShowModal((prev) => !prev);

  const handleClickInserirNovaTransfFin = () => {
    handleClearForm();
    setUpdatingTransferenciaFinanceira(false);
    handleShowModal();
  };

  const handleRowClickTransfFin = (id: string) => {
    setTransferenciaFinanceiraId(id);
    setUpdatingTransferenciaFinanceira(true);
    setShowModal(true);

    const itemSelecionado = data?.find((d) => d.id === id);
    if (itemSelecionado) {
      const dataTransfFin = itemSelecionado.dataContrato
        ? new Date(itemSelecionado.dataContrato).toISOString().split('T')[0]
        : '';

      const valorTotalDolares =
        itemSelecionado.valorTransferido / itemSelecionado.cotacaoDolar;

      setFormTransferenciaFinanceira({
        id: itemSelecionado.id,
        usuarioId: userID,
        orgInterId: orgInter,
        statusTransferencia: itemSelecionado.statusTransferencia || 0,
        dataContrato: dataTransfFin,
        contratoCambio: itemSelecionado.contratoCambio || 'Não informado',
        valorTransferido: formatValorDinheiro(itemSelecionado.valorTransferido),
        valorTotalDolares: formatarValorFormatoDinheiro(valorTotalDolares),
        cotacaoDolar: formatValorDinheiro(itemSelecionado.cotacaoDolar),
        observacoes: itemSelecionado.observacoes || '',
      });

      setLogData({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }
  };

  //////FUNÇÕES CRUD
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    let novoValor = value;

    const camposCalculo = ['cotacaoDolar', 'valorTransferido'];

    if (camposCalculo.includes(name)) {
      novoValor = formatoMoney(value, 2);

      const cotacao =
        name === 'cotacaoDolar'
          ? parseInputMonetario(value)
          : parseInputMonetario(
              formTransferenciaFinanceira.cotacaoDolar?.toString() || '0',
            );

      const valorTransferido =
        name === 'valorTransferido'
          ? parseInputMonetario(value)
          : parseInputMonetario(
              formTransferenciaFinanceira.valorTransferido?.toString() || '0',
            );

      const cotacaoValida = isNaN(cotacao) || cotacao === 0 ? 0 : cotacao; // Evita divisão por zero
      const totalDolares =
        cotacaoValida === 0 ? 0 : Number(valorTransferido) / cotacaoValida;

      const totalFormatado = formatarValorFormatoDinheiro(totalDolares);

      setFormTransferenciaFinanceira((prev: TransferenciaFinanceiraType) => ({
        ...prev,
        [name]: novoValor,
        valorTotalDolares: totalFormatado,
      }));
      return;
    }

    setFormTransferenciaFinanceira((prev: TransferenciaFinanceiraType) => ({
      ...prev,
      [name]: novoValor,
    }));
  };

  const adjustFormTransFinBeforeSubmit = (form: any) => {
    const adjustedForm = {
      ...form,
      statusTransferencia: Number(form.statusTransferencia),
      cotacaoDolar: Number(
        form.cotacaoDolar.replace(/\./g, '').replace(',', '.'),
      ),
      valorTransferido: Number(
        form.valorTransferido.replace(/\./g, '').replace(',', '.'),
      ),

      //Observações
      observacoes:
        form.observacoes === ''
          ? 'Sem observações específicas.'
          : form.observacoes,
    };

    // Remover campos não desejados
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { valorTotalDolares, ...cleanForm } = adjustedForm;

    return cleanForm;
  };

  const validateForm = (form: any) => {
    const erros = [];
    if (!form.contratoCambio)
      erros.push('<b>Nº do Contrato de Câmbio</b> é obrigatório.');
    if (!form.dataContrato) erros.push('<b>Data de Cotação</b> é obrigatório.');
    if (!form.valorTransferido)
      erros.push('<b>Valor Transferido</b> é obrigatório.');
    if (!form.cotacaoDolar)
      erros.push('<b>Cotação do Dólar</b> é obrigatório.');

    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }

    return true;
  };

  const handleCreate = async () => {
    try {
      if (!validateForm(formTransferenciaFinanceira))
        throw new Error('Formulário inválido.');

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormTransFinBeforeSubmit(
        formTransferenciaFinanceira,
      );
      await httpClient.post(`/api/orginter-transffinanceira`, adjustedForm);
      swalSave();
      fetchTransferenciaFinanceira();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(formTransferenciaFinanceira))
        throw new Error('Formulário inválido.');

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormTransFinBeforeSubmit(
        formTransferenciaFinanceira,
      );

      const response = await httpClient.patch(
        `/api/orginter-transffinanceira/${transferenciaFinanceiraId}`,
        adjustedForm,
      );
      swalAtualizacao('Sucesso', response.data.message);
      fetchTransferenciaFinanceira();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await httpClient.delete(
        `/api/orginter-transffinanceira/${transferenciaFinanceiraId}`,
      );
      swalDeleteConfirm();
      fetchTransferenciaFinanceira();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  //USE EFFECT
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';

    const status = String(formTransferenciaFinanceira.statusTransferencia);

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? verde
            : status === '3'
              ? vermelho
              : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formTransferenciaFinanceira.statusTransferencia]);

  return (
    <BoxConteudo boxTitulo="Transferências Financeiras">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersTransferenciasOrgInter}
            dataTable={tableData}
            displayValues={valoresExibidosTransferenciasOrgInter}
            onRowClick={handleRowClickTransfFin}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            setUpdatingTransferenciaFinanceira(false);
            handleClickInserirNovaTransfFin();
          }}
          //   disabled={fichaID == 'undefined' ? true : false}
        />
      </CustomCol>

      {/* Modal Fiscal /*/}
      <Modal
        tituloModal="Registro de Transferência Financeira"
        open={showModal}
        onHide={handleShowModal}
      >
        <WorkspaceFicha>
          <Log
            {...logData}
            entity="TB_ORG_INTER_TRANSF_FIN"
            id={Number(formTransferenciaFinanceira.id)}
          />
          <BoxConteudo boxTitulo="Item">
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="350px">
                <Select
                  name="statusTransferencia"
                  options={statusTransFin}
                  label="Status"
                  value={formTransferenciaFinanceira.statusTransferencia}
                  onChange={handleChange}
                  style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  id="contratoCambio"
                  name="contratoCambio"
                  label="Nº do Contrato de Câmbio"
                  value={formTransferenciaFinanceira.contratoCambio}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="190px">
                <Input
                  id="dataContrato"
                  name="dataContrato"
                  type="date"
                  value={formTransferenciaFinanceira.dataContrato}
                  label="Data do Contrato"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            <CustomRow>
              <CustomCol width="250px">
                <Input
                  id="valorTransferido"
                  name="valorTransferido"
                  value={formTransferenciaFinanceira.valorTransferido}
                  label="Valor Total em R$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="190px">
                <Input
                  id="cotacaoDolar"
                  name="cotacaoDolar"
                  value={formTransferenciaFinanceira.cotacaoDolar}
                  label="Cotação do Dólar em R$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  id="valor"
                  name="valorUnitario"
                  value={formTransferenciaFinanceira.valorTotalDolares || ''}
                  label="Total em US$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  value={formTransferenciaFinanceira.observacoes}
                  label="Observações"
                  linhas={5}
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
          <BarraInferiorBotoes>
            {updatingTransferenciaFinanceira ? (
              <WorkspaceBotoes
                delete
                // deleteDisabled={btDisable}
                onClickDelete={handleDelete}
                save
                // saveDisabled={btDisable}
                onClickSave={handleUpdate}
              />
            ) : (
              <WorkspaceBotoes
                inserir
                // inserirDisabled={btDisable}
                onClickInserir={handleCreate}
              />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </Modal>
    </BoxConteudo>
  );
}
